import React, { useRef } from 'react'
import style from "css/todayReservation.module.css";
import { ReactComponent as DownArrow } from "asset/calendar/arrow_down.svg";
import { Button, Dropdown, Menu, Space } from 'antd';
// import style from "css/mypage.module.css";
import { DownOutlined } from '@ant-design/icons';

function ParticipantDropdown({ participants }) {
    const menu = (
        <Menu>
            {participants.map((participant, idx) => (
                <Menu.Item key={idx}>
                    {participant.MEMBER_NM}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <Dropdown overlay={menu}>
            <div
                onClick={(e) => e.preventDefault()}
                className={style.ptcp_dropdown_wrapper}
            >
                <div className={style.ptcp_dropdown_container}>
                    {`${participants.length}명`}
                    <DownOutlined />
                </div>
            </div>
        </Dropdown>
    )
}

export default ParticipantDropdown
